// src/pages/AccesClients.js
import React, { useState } from "react";
import "../index.css";
import CLIENTS from "../data/clients";
import { trackEvent } from "../analytics/ga"; // <-- important

export default function AccesClients() {
  const [code, setCode] = useState("");
  const [client, setClient] = useState(null);
  const [error, setError] = useState("");

  function normalize(s) {
    return (s || "").trim().toLowerCase();
  }

  function handleSubmit(e) {
    e.preventDefault();
    const needle = normalize(code);
    const found = CLIENTS.find((c) => normalize(c.code) === needle);

    if (!needle) {
      setError("Merci d’entrer votre code d’accès.");
      setClient(null);
      return;
    }
    if (!found) {
      setError("Code invalide. Vérifiez les majuscules / minuscules ou contactez HLBK.");
      setClient(null);
      return;
    }
    setError("");
    setClient(found);
  }

  return (
    <section className="clients-page">
      <header className="clients-hero">
        <h1>Accès clients</h1>
        <p>Entrez votre mot de passe pour accéder à votre galerie privée.</p>
      </header>

      {/* Formulaire */}
      {!client && (
        <form className="clients-form" onSubmit={handleSubmit}>
          <label htmlFor="client-code" className="sr-only">Code d’accès</label>
          <input
            id="client-code"
            type="text"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="Votre code (ex. DE_0823)"
            autoComplete="off"
            aria-invalid={!!error}
          />
          <button type="submit" className="btn-solid">Valider</button>
          {error && <p className="form-error">{error}</p>}
        </form>
      )}

      {/* Résultat */}
      {client && (
        <div className="client-card">
          <h2>{client.name}</h2>
          <p>Votre galerie est prête. Vous pouvez l’ouvrir ci-dessous.</p>

          <div className="client-actions">
            <a
              href={client.pcloudLink}
              target="_blank"
              rel="noreferrer"
              className="btn-solid"
              onClick={() =>
                trackEvent({
                  action: "client_portal_open",
                  category: "clients",
                  label: client.id,
                })
              }
            >
              Ouvrir la galerie
            </a>

            {client.zip && (
              <a
                href={client.zip}
                className="btn-ghost"
                download
                onClick={() =>
                  trackEvent({
                    action: "download_zip",
                    category: "clients",
                    label: client.id,
                  })
                }
              >
                Télécharger le ZIP
              </a>
            )}
          </div>

          <button
            className="link-as-button"
            onClick={() => {
              setClient(null);
              setCode("");
            }}
          >
            ⟵ Saisir un autre code
          </button>
        </div>
      )}
    </section>
  );
}